import {PRODUCTION, STAGING} from './environments';
import {Locale} from './RootProvider/LocaleContext';

export const MINIMUM_REQUEST_AMOUNT = 1000;
export const MAXIMUM_REQUEST_AMOUNT = 15000000;

export const DEFAULT_LOCALE = Locale.uk;

export const BLOG_ARTICLES_PER_PAGE = 9;
export const PRODUCTS_PER_PAGE = 8;
export const MULTI_PRODUCTS_PER_PAGE = 7; // DO NOT raise this number above 10 - it'll cause issues!!
export const SORT_SELECTED_PRODUCTS_ASCENDING = false;

// cookies
export const AFFID_COOKIE_NAME = 'affid';
export const CONSENT_COOKIE_NAME = 'cookieConsent';
export const FOID_COOKIE_NAME = 'foid';
export const LANDING_URL_COOKIE_NAME = 'landingUrl';
export const UPDATES_STRIP_COOKIE_NAME = 'homepageUpdatesStrip';
export const LANGUAGE_COOKIE_NAME = 'displayLang';
export const COMPLIANCE_COOKIE_NAME = 'complianceConsent';

export const cookieDomain =
  process.env.STAGE === PRODUCTION
    ? // on prod, use '.fundingoptions.com' as the cookie domain, to support our whitelabelling (`abc.fundingoptions.com`)
      '.fundingoptions.com'
    : // All other cases should default to the current `location.host`, to prevent cookies bleeding between
      // our different environments.
      undefined;
export const hasSecureCookie = process.env.STAGE === PRODUCTION || process.env.STAGE === STAGING;

// events
export const UPDATE_USER_EVENT = 'identity.update';
export const UPDATE_APPLICATIONS_EVENT = 'user.applications.update';
export const UPDATE_LANG_EVENT = 'ui.update.lang';

// URIs
export const ADDRESS_LOOKUP_API = 'https://api.getAddress.io/find/';

// Errors
export const JWT_ERROR = 'Jwt token not provided';
export const AXIOS_CANCEL = 'axios.cancel';

// Date

export const DATE_FORMAT_DAY = 'dd';
export const DATE_FORMAT_MONTH = 'mm';
export const DATE_FORMAT_YEAR = 'yyyy';
